const listStyles = (tokens) => ({
    variants: {
        sidebar: {
            background: 'red',
            container: {
                '-webkit-margin-start': '0px !important',
                'margin-inline-start': '0px !important',
                marginBottom: tokens.Spacing05,
                marginRight: '1px',
            },
            item: {
                height: '48px',
                paddingTop: tokens.Spacing04,
                fontWeight: tokens.TextHeadingLight6FontWeight,
                paddingLeft: tokens.Spacing05,
                paddingRight: tokens.Spacing05,
                pointer: 'cursor',
                color: tokens.TextDark800,
                margin: '0px',
                borderBottomWidth: tokens.BorderWidth01,
                borderBottomColor: tokens.BorderLight200,
                display: 'block',
                p: {
                    marginBottom: '0px',
                },
            },
        },
        typeahead: {
            container: {
                marginTop: tokens.Spacing02,
                borderRadius: tokens.Spacing02,
                position: 'absolute',
                width: '100%',
                zIndex: 1,
                maxH: '140px',
                overflowY: 'auto',
                borderLeftColor: tokens.BorderLight200,
                borderLeftWidth: tokens.BorderWidth01,
                shadow: '1px 1px 6px 1px rgba(0,0,0,0.6)',
            },
            item: {
                background: tokens.Layer01,
                padding: tokens.Spacing03,
                borderBottomWidth: tokens.BorderWidth01,
                borderBottomColor: tokens.BorderLight200,
                cursor: 'pointer',
                _hover: {
                    background: tokens.SecondaryNavigationHover,
                },
            },
        },
    },
});
export default listStyles;
